/** Last-known diagram count per editor kind, used to size the gallery's
 *  loading skeleton so it approximates the user's real library instead of a
 *  hardcoded guess. Persisted in localStorage, mirroring the guarded direct
 *  pattern of preferences/input-mode-preference.ts. Clamped on read: min 1
 *  (a returning empty-library user still sees one brief placeholder, not a
 *  blank flash), max 12 (a large library doesn't paint a wall of skeletons). */

const FALLBACK_COUNT = 4;
const MIN_COUNT = 1;
const MAX_COUNT = 12;

export function readSkeletonCount(storageKey: string): number {
    try {
        const stored = window.localStorage.getItem(storageKey);
        if (stored == null || !/^\d+$/.test(stored)) return FALLBACK_COUNT;
        return Math.min(MAX_COUNT, Math.max(MIN_COUNT, Number(stored)));
    } catch {
        return FALLBACK_COUNT;
    }
}

export function writeSkeletonCount(storageKey: string, count: number): void {
    try {
        window.localStorage.setItem(storageKey, String(count));
    } catch {
        // Ignore storage failures (private mode, etc.) — the skeleton count
        // is a cosmetic hint, not state.
    }
}
